import api from "./../api";
import UtilsUrl from "../../utils/UtilsUrl";

const uploadCSVFile = async (file, userId) => {
  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await api.post(
      UtilsUrl.rhURL() + "/Attendance/importCSV/" + userId,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data; // Upload success
  } catch (error) {
    console.error(error);
    return error; // Upload error
  }
};

const uploadCSVFileLF = async (file, userId) => {
  const formData = new FormData();
  formData.append("file", file);

  
  return  api.post(
      UtilsUrl.rhURL() + "/Attendance/importCSVLFModel/" + userId,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  
};

const getAllMonthAttendance = async (selectedMonth, selectedYear) => {
  const response = await api.get(
    UtilsUrl.rhURL() +
      `/Attendance/attendanceList?month=${selectedMonth}&year=${selectedYear}`
  );
  return response.data;
};
const getFilredUser = async (idUser, filter) => {
  const res = await api.get(
    UtilsUrl.rhURL() + `/Attendance/filteredUserAttendance/${idUser}/${filter}`
  );
  console.log(res.data);
  return res.data;
};
export { uploadCSVFile, getAllMonthAttendance, getFilredUser,uploadCSVFileLF };
